import { tiposDocumento } from "@/config/constants";
export default {
  // Estado del loader
  // Inicialmente mostramos el loader
  // luego de que carga la primera vista
  // lo quitamos
  error: {},
  isLoading: false,
  forzarDNE: {},
  notificationToast: {
    // [info, success, alert]
    type: "",
    message: "",
    theme: ""
  },
  notificationModal: {
    // [info, success, alert]
    type: "",
    title: "",
    message: ""
  },
  consulta: {
    codigoProvincia: "",
    tipoDocumento: tiposDocumento.DNI,
    numeroDoc: "",
    patente: "",
    condicion: "S",
    anio: String(new Date().getFullYear()),
    marca: "1",
    modelo: "",
    version: "",
    gnc: "",
    codigoPostal: "",
    domicilioParticular: {
      calle: "",
      numero: "",
      localidad: "",
      provincia: "01"
    },
    captcha: "",
    destino: "",
    metros: ""
  },
  merlin: {
    error: "",
    valido: null
  },
  marcasAuto: [],
  modelosAuto: [],
  versionesAuto: [],
  resultadosCotizacion: {},
  // Model del paso 1
  paso1: {
    nombre: "",
    apellido: "",
    numeroDoc: "",
    email: "",
    fechaNacimiento: "",
    tipoDocumento: tiposDocumento.DNI
  },
  paso2: {
    seleccion: "",
    vivienda: ""
  },
  paso1Hogar: {
    metros: "",
    vivienda: "",
    viviendaDescripcion: "",
    codigoPostal: ""
  },
  paso3Hogar: {},
  paso4Hogar: {},
  isAutomotor: true,
  tiposDeVivienda: [],
  cotizacionHogar: {
    cuotaSeguro: "101",
    sumaAsegurada: "101",
    coberturasHogar: [
      {
        codCoberReemplazo: "",
        codigoCobertura: "102",
        descripcionCobertura: "INCENDIO CONTENIDO",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000002500000000",
        obligatoria: "S",
        monto: "000002100000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "103",
        descripcionCobertura: "RESPONSABILIDAD CIVIL LINDEROS",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000002200000000",
        obligatoria: "N",
        monto: "000000060000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "115",
        descripcionCobertura: "P?RDIDA DE ALIMENTOS",
        esEditable: "S",
        minimo: "000000000100000",
        maximo: "000000006000000",
        obligatoria: "S",
        monto: "000000006000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "104",
        descripcionCobertura: "GASTOS DE ALOJAMIENTO",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000000075000000",
        obligatoria: "S",
        monto: "000000075000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "110",
        descripcionCobertura: "INCENDIO EDIFICIO A PRIMER RIESGO ABSOLUTO",
        esEditable: "N",
        minimo: "000006000000000",
        maximo: "000006000000000",
        obligatoria: "S",
        monto: "000006000000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "112",
        descripcionCobertura: "GASTOS DE LIMPIEZA, ESCOMBROS Y DEMOLICI?N",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000000230000000",
        obligatoria: "S",
        monto: "000000230000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "113",
        descripcionCobertura: "HONORARIOS PROFESIONALES",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000000035000000",
        obligatoria: "S",
        monto: "000000035000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "114",
        descripcionCobertura: "DA?OS EST?TICOS",
        esEditable: "S",
        minimo: "000000002000000",
        maximo: "000000275000000",
        obligatoria: "S",
        monto: "000000275000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "201",
        descripcionCobertura: "ROBO O HURTO DEL CONTENIDO",
        esEditable: "S",
        minimo: "000000003000000",
        maximo: "000000300000000",
        obligatoria: "S",
        monto: "000000060000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "211",
        descripcionCobertura: "TODO RIESGO EQUIPOS ELECTROMEC?NICOS",
        esEditable: "S",
        minimo: "000000000500000",
        maximo: "000000150000000",
        obligatoria: "S",
        monto: "000000000500000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "212",
        descripcionCobertura: "ROBO DINERO EFVO DOM",
        esEditable: "S",
        minimo: "000000000050000",
        maximo: "000000000650000",
        obligatoria: "N",
        monto: "000000000650000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "215",
        descripcionCobertura: "TR EQUIPOS PORT?TILES EN EL MUNDO",
        esEditable: "S",
        minimo: "000000000100000",
        maximo: "000000150000000",
        obligatoria: "S",
        monto: "000000000100000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "234",
        descripcionCobertura: "ROBO OBJ ESPECIFICOS",
        esEditable: "S",
        minimo: "000000000100000",
        maximo: "000000003000000",
        obligatoria: "N",
        monto: "000000001800000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "301",
        descripcionCobertura: "CRISTALES",
        esEditable: "S",
        minimo: "000000000100000",
        maximo: "000000060000000",
        obligatoria: "S",
        monto: "000000000100000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "403",
        descripcionCobertura: "ACCIDENTES PERS.",
        esEditable: "S",
        minimo: "000000010000000",
        maximo: "000000300000000",
        obligatoria: "N",
        monto: "000000010000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "501",
        descripcionCobertura: "RESPONSABILIDAD CIVIL PRIVADA",
        esEditable: "S",
        minimo: "000000005000000",
        maximo: "000002000000000",
        obligatoria: "N",
        monto: "000000005000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "502",
        descripcionCobertura: "RESP CIVIL DOMESTICO",
        esEditable: "S",
        minimo: "000000010000000",
        maximo: "000000300000000",
        obligatoria: "N",
        monto: "000000010000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "601",
        descripcionCobertura: "DA?OS POR AGUA",
        esEditable: "S",
        minimo: "000000000500000",
        maximo: "000000150000000",
        obligatoria: "N",
        monto: "000000000500000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "700",
        descripcionCobertura: "MASCOTAS",
        esEditable: "S",
        minimo: "000000000500000",
        maximo: "000000010000000",
        obligatoria: "N",
        monto: "000000000500000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "701",
        descripcionCobertura: "COBERTURA GOLF",
        esEditable: "N",
        minimo: "000000033800000",
        maximo: "000000033800000",
        obligatoria: "N",
        monto: "000000033800000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      }
    ]
  },
  recotizacionHogar: {
    cuotaSeguro: "01",
    idCotizacion: "01",
    sumaAsegurada: "01",
    coberturasHogar: [
      {
        codCoberReemplazo: "",
        codigoCobertura: "102",
        descripcionCobertura: "INCENDIO CONTENIDO",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000002500000000",
        obligatoria: "S",
        monto: "000002100000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "103",
        descripcionCobertura: "RESPONSABILIDAD CIVIL LINDEROS",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000002200000000",
        obligatoria: "N",
        monto: "000000060000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "115",
        descripcionCobertura: "P?RDIDA DE ALIMENTOS",
        esEditable: "S",
        minimo: "000000000100000",
        maximo: "000000006000000",
        obligatoria: "S",
        monto: "000000006000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "104",
        descripcionCobertura: "GASTOS DE ALOJAMIENTO",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000000075000000",
        obligatoria: "S",
        monto: "000000075000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "110",
        descripcionCobertura: "INCENDIO EDIFICIO A PRIMER RIESGO ABSOLUTO",
        esEditable: "N",
        minimo: "000006000000000",
        maximo: "000006000000000",
        obligatoria: "S",
        monto: "000006000000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "112",
        descripcionCobertura: "GASTOS DE LIMPIEZA, ESCOMBROS Y DEMOLICI?N",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000000230000000",
        obligatoria: "S",
        monto: "000000230000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "113",
        descripcionCobertura: "HONORARIOS PROFESIONALES",
        esEditable: "S",
        minimo: "000000001000000",
        maximo: "000000035000000",
        obligatoria: "S",
        monto: "000000035000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "114",
        descripcionCobertura: "DA?OS EST?TICOS",
        esEditable: "S",
        minimo: "000000002000000",
        maximo: "000000275000000",
        obligatoria: "S",
        monto: "000000275000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "201",
        descripcionCobertura: "ROBO O HURTO DEL CONTENIDO",
        esEditable: "S",
        minimo: "000000003000000",
        maximo: "000000300000000",
        obligatoria: "S",
        monto: "000000060000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "211",
        descripcionCobertura: "TODO RIESGO EQUIPOS ELECTROMEC?NICOS",
        esEditable: "S",
        minimo: "000000000500000",
        maximo: "000000150000000",
        obligatoria: "S",
        monto: "000000000500000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "212",
        descripcionCobertura: "ROBO DINERO EFVO DOM",
        esEditable: "S",
        minimo: "000000000050000",
        maximo: "000000000650000",
        obligatoria: "N",
        monto: "000000000650000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "215",
        descripcionCobertura: "TR EQUIPOS PORT?TILES EN EL MUNDO",
        esEditable: "S",
        minimo: "000000000100000",
        maximo: "000000150000000",
        obligatoria: "S",
        monto: "000000000100000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "234",
        descripcionCobertura: "ROBO OBJ ESPECIFICOS",
        esEditable: "S",
        minimo: "000000000100000",
        maximo: "000000003000000",
        obligatoria: "N",
        monto: "000000001800000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "301",
        descripcionCobertura: "CRISTALES",
        esEditable: "S",
        minimo: "000000000100000",
        maximo: "000000060000000",
        obligatoria: "S",
        monto: "000000000100000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "403",
        descripcionCobertura: "ACCIDENTES PERS.",
        esEditable: "S",
        minimo: "000000010000000",
        maximo: "000000300000000",
        obligatoria: "N",
        monto: "000000010000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "501",
        descripcionCobertura: "RESPONSABILIDAD CIVIL PRIVADA",
        esEditable: "S",
        minimo: "000000005000000",
        maximo: "000002000000000",
        obligatoria: "N",
        monto: "000000005000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "502",
        descripcionCobertura: "RESP CIVIL DOMESTICO",
        esEditable: "S",
        minimo: "000000010000000",
        maximo: "000000300000000",
        obligatoria: "N",
        monto: "000000010000000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "601",
        descripcionCobertura: "DA?OS POR AGUA",
        esEditable: "S",
        minimo: "000000000500000",
        maximo: "000000150000000",
        obligatoria: "N",
        monto: "000000000500000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "700",
        descripcionCobertura: "MASCOTAS",
        esEditable: "S",
        minimo: "000000000500000",
        maximo: "000000010000000",
        obligatoria: "N",
        monto: "000000000500000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      },
      {
        codCoberReemplazo: "",
        codigoCobertura: "701",
        descripcionCobertura: "COBERTURA GOLF",
        esEditable: "N",
        minimo: "000000033800000",
        maximo: "000000033800000",
        obligatoria: "N",
        monto: "000000033800000",
        tipoCobertura: "",
        url: "",
        seleccionada: null
      }
    ]
  },
  coberturasAnadidas: [],
  coberturasSeleccionadas: [],
  userIdTokenizado: "",
  celularNormalizado: {
    numero: "",
    normalizado: {
      valido: false
    }
  }
};
